import { cn } from '@/lib/utils';

export function Heading1({ children, className }: React.ComponentProps<'h1'>) {
  return (
    <h1
      className={cn(
        'font-martina mb-8 text-[32px] leading-[115%] font-normal tracking-tight sm:mb-12 sm:text-[48px]',
        className
      )}
    >
      {children}
    </h1>
  );
}
